import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      ...item,
      key: item.id,
      select: { id: item.id, value: false },
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

// `query` is optional - omitting it returns the first page of the whole catalogue. Follow-up pages
// are loaded from the response's ready-made `next` URL (it carries the cursor), so no params then.
function* getCodesProductsScroll({ payload: { signal, searchQ, pageUrl } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.shopify.search_products,
      ...(pageUrl ? { url: pageUrl } : { params: { ...(searchQ && { query: searchQ }), include_variants: false } }),
      signal
    });

    yield put(actions.getCodesProductsScrollDone({
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.previous ?? null,
      append: Boolean(pageUrl)
    }));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCodesProductsScrollFailed,
      // Every caller shows the `query` error (e.g. under 3 characters) under its search field
      handledErrors: ['query'],
      endpoint: api.shopify.search_products.url
    });
  }
}

export const getCodesProductsScrollSaga = takeEvery(
  types.GET_CODES_PRODUCTS_SCROLL_REQUEST,
  getCodesProductsScroll
);
